module.exports = __webpack_public_path__ + "media/images/pdf-file-21b4a0c3.png";